/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/member-ordering */
import { ITask, Nullable } from './ITask';
import pureTaskQueue from '@src/slide/infrastructure/module/dependent/taskManager/pure-task-queue';

/**
 * 默认execution为同步任务
 * 如果需要支持异步任务
 * 通常情况下只需要继承重写execute方法
 * 等待任务结束后调用finish方法以确保任务正确结束并回收资源
 */
export default class Task implements ITask {
    public readonly key: string;

    // 优先级
    public priority: number;

    // 是否正在执行（默认执行过程中的任务不可取消）
    public isExecuting: boolean;

    // 是否被取消执行
    public isCanceled: boolean;

    public isPaused: boolean;

    public concurrent: boolean;

    public isFinished: boolean;

    public waitGroupComplete: boolean;

    public enableWorker: boolean;
    public performedInWorker: boolean;

    public promise: Promise<any>;

    // 需要执行的操作
    public execution: Nullable<() => Promise<any> | void>;

    public completeCallback: Nullable<(task: ITask) => void>;

    private executionID: any;
    private resolveFnc: Nullable<(value: unknown) => void>;

    public constructor(key: string, priority: number, execution: Nullable<() => Promise<any> | void>) {
        this.key = key;
        this.priority = priority;
        this.execution = execution;

        this.reset();
    }

    public reset() {
        this.isExecuting = false;
        this.isCanceled = false;
        this.isPaused = false;
        this.isFinished = false;

        this.promise = new Promise((resolve) => {
            this.resolveFnc = resolve;
        });
    }

    public asyncStart() {
        this.executionID = pureTaskQueue.add(() => {
            this.execute();
        });
    }

    public start() {
        this.execute();
    }

    public async execute() {
        let result;
        if (!this.isPaused && !this.isCanceled) {
            this.isExecuting = true;
            if (this.execution) {
                result = this.execution();
                if (result) {
                    result = await result;
                }
            }
            this.isExecuting = false;
        }

        if (!this.isExecuting) {
            this.finish(result);
        }
    }

    public finish(res?: any) {
        this.isFinished = true;

        this.executionID && pureTaskQueue.remove(this.executionID);
        this.resolveFnc?.(res);
    }

    public cancel() {
        if (!this.isExecuting) {
            this.isCanceled = true;
            this.finish();
        }
    }

    public pause() {
        if (!this.isExecuting) {
            this.isPaused = true;
            this.finish();
        }
    }

    public resume() {
        this.isPaused = false;
    }

    public notifyComplete() {
        this.completeCallback?.(this);
    }
}

